import { render, staticRenderFns } from "./DashboardGeschaeftsfuehrung.vue?vue&type=template&id=6516ac95&scoped=true"
import script from "./DashboardGeschaeftsfuehrung.vue?vue&type=script&lang=js"
export * from "./DashboardGeschaeftsfuehrung.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6516ac95",
  null
  
)

export default component.exports